'use es6';

import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import StoredContentContainer from '../../containers/StoredContentContainer';
import { LearningContentContainer } from '../../features/learningContent';
import LessonInfoTabs from '../LessonPage/LessonInfoTabs';
import { SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS } from '../../constants/Navigation';
import { OptionalToolRecommendationSection } from '../../features/toolRecommendations';
import { TrackContentWithInteractiveEducation } from './TrackContentWithInteractiveEducation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackPage = ({
  track,
  onAdvanceContent,
  lesson,
  contentId,
  fullLesson,
  fullTrack
}) => {
  const trackId = Number(track.get('id'));
  const lessonId = Number(lesson.get('id'));
  const language = track.get('language');
  const lessonIds = track.get('lessonIds') || [];
  const indexOfLessonInTrackLessons = lessonIds.indexOf(lessonId);
  const nextLessonId = lessonIds.get(indexOfLessonInTrackLessons + 1);
  const fullContent = fullLesson && fullLesson.content ? fullLesson.content.find(c => String(c.id) === String(contentId)) : undefined;
  if (contentId === SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(OptionalToolRecommendationSection, {
        contentName: lesson.get('name'),
        lessonId: lessonId,
        nextLessonId: nextLessonId ? String(nextLessonId) : undefined,
        trackId: String(trackId),
        useCases: lesson.get('useCases')
      }), /*#__PURE__*/_jsx(LessonInfoTabs, {
        fullLesson: fullLesson,
        trackId: trackId
      })]
    });
  }
  if (fullContent && fullContent.contentType === 'VIDEO') {
    return /*#__PURE__*/_jsx(TrackContentWithInteractiveEducation, {
      contentId: contentId,
      lesson: fullLesson,
      onAdvanceContent: onAdvanceContent,
      track: fullTrack,
      videoContent: fullContent
    }, contentId);
  }
  return /*#__PURE__*/_jsxs(LearningContentContainer, {
    contentId: Number(contentId),
    language: language,
    lessonId: lessonId,
    trackId: trackId,
    children: [/*#__PURE__*/_jsx(StoredContentContainer, {
      contentId: contentId,
      isParentGraded: lesson.get('graded'),
      isPubliclyVisible: lesson.get('visibility') === 'PUBLIC',
      language: language,
      lessonId: String(lessonId),
      lessonName: lesson.get('name'),
      onFinish: onAdvanceContent,
      trackId: String(trackId),
      trackName: track.get('name')
    }), /*#__PURE__*/_jsx(LessonInfoTabs, {
      contentId: contentId,
      fullLesson: fullLesson,
      trackId: trackId
    })]
  });
};
TrackPage.propTypes = {
  contentId: PropTypes.string.isRequired,
  fullLesson: PropTypes.object,
  fullTrack: PropTypes.object,
  lesson: ImmutablePropTypes.map.isRequired,
  onAdvanceContent: PropTypes.func.isRequired,
  track: ImmutablePropTypes.map.isRequired
};
export default TrackPage;